import MainAboutUs from '../AboutUs/MainAboutUs';
import NavigationBar from '../NavigationBar/NavigationBar';
import { Footer } from './Footer/Footer';
import { Hero } from './Hero/Hero';
import PopularStories from './Popular/PopularStories';
import { Stories } from './StoryCard/Stories';
import TestimonialsSection from './Testimonials/TestimonialsSection';
import Welcome from './Welcome/Welcome';

function MainPage() {
  return (
    <div className="App">
      <NavigationBar />
      <Hero/>
      <Welcome />
      <Stories />
      <PopularStories />
      <TestimonialsSection />
      <Footer />
    </div>
  );
}

export default MainPage;
